<template>
    <span>
        <el-table-column label="运营数据" width="200" align="center">
            <div slot-scope="scope" class="fixedHeight">

                <div v-if="scope.row.production_asins && scope.row.production_asins.main_seller_asin" @click="updateAsin(scope.row)">
                    <div>主卖ASIN: {{ scope.row.production_asins.main_seller_asin }}</div>
                </div>

                <div v-if="scope.row.production_asins && scope.row.production_asins.skag_keywords" @click="updateAsin(scope.row)">
                    <div>SKAG关键词: {{ scope.row.production_asins.skag_keywords.join(',') }}</div>
                </div>

                <div v-if="scope.row.production_asins && scope.row.production_asins.not_main_seller_asins" @click="updateAsin(scope.row)">
                    <div>非主卖ASIN: {{ scope.row.production_asins.not_main_seller_asins.join(',') }}</div>
                </div>

                <div v-else-if="Object.keys(scope.row.production_asins || {}).length > 0" class="asinBox" @click="updateAsin(scope.row)">
                    <div v-for="(item, key) of scope.row.production_asins" :key="key">
                        {{ key }} ({{ item === 1 ? '主卖' : '非主卖' }})
                    </div>
                </div>
            </div>
        </el-table-column>

        <updateCompletedProductionDialog ref="updateCompletedProductionRef" @close-callback="closeCllback"/>
    </span>
</template>

<script>
import updateCompletedProductionDialog from '@/views/linkProduction/depend/updateProductionAsinDialog.vue'

export default {
    name: 'productionAsins',
    components: {updateCompletedProductionDialog},
    props: {
        needUpdate: {
            type: Boolean,
            default: false
        },
        viewType: {
            type: String,
            default: 'production_asins'
        }
    },
    data() {
        return {}
    },
    methods: {
        updateAsin(data) {
            this.$refs.updateCompletedProductionRef.showModal(data, this.needUpdate, this.viewType)
        },
        closeCllback(isshow) {
            this.$emit('close-callback', isshow)
        }
    }
}
</script>
<style lang="scss" scoped>
.fixedHeight {
    height: 50px;
    line-height: 15px;
    overflow: hidden;
    text-overflow: ellipsis;
}

</style>
